import React, { FC, MutableRefObject, ReactNode, forwardRef, useEffect, useRef } from "react";
import { createPortal } from "react-dom";

function createOverlayElement() {
  const el = document.createElement("div");
  el.style.position = "absolute";
  el.style.display = "block";
  // el.style.border = "1px dashed red";
  return el;
}
interface Props {
  map: google.maps.Map | null;
  position: { lat: number; lng: number };
  children?: ReactNode;
}
const OverlayContainer = forwardRef<HTMLDivElement, Props>(({ map, position, children }, ref) => {
  const overlay = useRef<google.maps.OverlayView | null>();
  const el = useRef<HTMLDivElement | null>();

  // modified OverlayView from google.maps [https://developers.google.com/maps/documentation/javascript/reference/3.44/overlay-view?hl=en]
  class OverlayView extends window.google.maps.OverlayView {
    position: google.maps.LatLng | null = null;
    content: any = null;

    constructor(props: any) {
      super();
      props.position && (this.position = props.position);
      props.content && (this.content = props.content);
    }

    onAdd = () => {
      if (this.content) {
        this?.getPanes()?.floatPane?.appendChild(this.content);
      }
    };

    onRemove = () => {
      if (this.content?.parentElement) {
        this.content.parentElement.removeChild(this.content);
      }
    };

    draw = () => {
      if (this.position) {
        const divPosition = this.getProjection()?.fromLatLngToDivPixel(this.position);
        this.content.style.left = `${divPosition?.x ?? 0}px`;
        this.content.style.top = `${divPosition?.y ?? 0}px`;
      }
    };
  }

  useEffect(() => {
    return () => {
      overlay?.current?.setMap(null);
    };
  }, []);

  if (map) {
    el.current = el.current || createOverlayElement();
    overlay.current = new OverlayView({
      position: new google.maps.LatLng(position.lat, position.lng),
      content: el.current,
    });
    overlay.current.setMap(map);
    return createPortal(children, el.current);
  }
  return null;
});
OverlayContainer.displayName = "OverlayContainer";
export default OverlayContainer;
